import { INTEGER_PRODUCTS, ProductKind } from 'constants/product'
import { IntegerProductTuple, ProductCategory } from 'models/product'

/**
 * Lazy function which compiles and memoizes a set of keys from integer product tuple array
 * @returns Function which evaluates whether provided combination of product category and product kind is and integer product
*/
function lazyIntegerProducts(integerProductTuples: IntegerProductTuple[]): (category: ProductCategory, kind: ProductKind) => boolean {
  let keys: Set<string>

  return (category: ProductCategory, kind: ProductKind) => {

    if (!keys) keys = new Set<string>(integerProductTuples.map((tuple) => tuple.join('::')))

    return keys.has(`${category}::${kind}`)
  }

}

/**
 * Function to evaluate whether provided category and kind combination is a integer product
 * @returns true if provided combination of product kind and category should have an integer quantity, false otherwise
*/
export const isIntegerProduct = lazyIntegerProducts(INTEGER_PRODUCTS)
